import { type FC, type ReactNode } from 'react';

import styles from './MobilePhotoWrapper.scss';

const MobilePhotoWrapper: FC<{ children: ReactNode }> = ({ children }) => {
    return <div className={styles.wrapper}>{children}</div>;
};

export default MobilePhotoWrapper;
